import { render } from "./CodeAcception.vue?vue&type=template&id=80eae9ce"
import script from "./CodeAcception.vue?vue&type=script&lang=js"
export * from "./CodeAcception.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__